export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
    seriesError: 'Je potrebné vybrať aspoň jednu možnosť',
  },
  calculator: {
    title: 'Výpočet úspor v aplikaci Walutomat',
    forBuy: 'pro',
    unsupportedPair: 'V současné době nenabízíme kurzy pro vybraný měnový pár.',
    spinnerError: {
      generic: 'Při stahování dat došlo k problému',
      toManyRequests:
        'Kalkulátor je momentálne nedostupný. Skúste to neskôr alebo kontaktujte <a href="https://www.walutomat.com/sk/kontakt/">Zákaznícky Servis</a>.',
    },
    commissionWT: 'Provízia Walutomat',
    ctaButton: 'Vymeniť',
    amountText: 'Částka',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Skontrolujte kurzy a{{nbsp}}premeňte menu v{{nbsp}}Walutomat – rýchlo a{{nbsp}}výhodne.',
    actualRate: 'Aktuálny kurz',
    buySelect: 'Kupujem',
    sellSelect: 'Predávam',
    exchangeAmountSellLabel: 'Dostanete',
    exchangeAmountBuyLabel: 'Vložte',
    commission: 'Propagačná provízia ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Pole nemôže byť prázdne',
    requiredField: 'Pole je povinné',
    requireAllFields: 'Všetky polia musia byť vyplnené',
    passwordToShort: 'Heslo musí mať 8 znakov',
    emailNotValid: 'Pole musí obsahovať platnú e-mailovú adresu',
    emailReserved: 'E-mailová adresa je už obsadená',
    emailUnregistered: 'Vašu e-mailovú adresu sme nenašli v našej databáze zákazníkov.',
    markField: 'Vyberte aspoň jedno z políč',
    serverUnknownError: 'Chyba komunikácie so serverom',
    invalidCharacters: 'Pole obsahuje neplatné znaky',
    phoneNotValid: 'Telefónne číslo je nesprávne',
    checkBoxBelow: 'Prosím, zaškrtnite políčko nižšie, aby ste mohli poslať správu',
    promocodeInvalid: 'Neplatný propagačný kód',
    newsletterAlreadySubscribed: 'Tento e-mail je už prihlásený na odber newslettera.',
  },
  password: {
    show: 'zobraziť',
    hide: 'skryt',
  },
  howItWorks: {
    showButton: 'Zobraziť viac',
    hideButton: 'Zobraziť menej',
  },
  rateCalculator: {
    baseInputLabel: 'Mam',
    counterInputLabel: 'Otrzymam',
    counterInputTooltip: 'Uwzględnia prowizję {{commission}}%',
    ctaAlert: 'Ustaw alert',
  },
  esim: {
    searchPlaceholder: 'Vyhľadajte krajinu alebo región...',
    searchAriaLabel: 'Vyhľadajte krajinu alebo región',
    searchMinChars: 'Zadajte <b>aspoň 3 znaky</b> pre zobrazenie výsledkov.',
    searchNoResults: '<b>Žiadne výsledky.</b> Hľadaná krajina nebola nájdená.',
    searchError: '<b>Vyskytla sa chyba.</b> Nepodarilo sa načítať zoznam ponúk.',
  },
}
